import React from "react";
import {Columns, Heading, Modal, Section, Table, Form} from "react-bulma-components";
import PartRow from "./PartRow";


export default function PartListModal({partOrder, show, setShow}){

    return (
        <Modal
            closeOnBlur
            show={show}
            onClose={() => setShow(false)}
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Parts for order {partOrder ? partOrder.id : ""}</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Form.Label>Customer Vehicle</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={partOrder ? partOrder.customer_vehicle : ""}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Customer Order Number</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={partOrder ? partOrder.order_number : ""}
                            />
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Table size={"fullwidth"}>
                                <thead>
                                    <tr>
                                        <th>Part Number</th>
                                        <th>Part Name</th>
                                        <th>Part Customer Charge</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {partOrder && partOrder.parts && partOrder.parts.map(part => (
                                        <PartRow
                                            part={part}
                                        />
                                    ))}
                                </tbody>
                            </Table>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )
}